export default function DocumentTitle(props){
    document.title = `${props.title}`
}